// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3U4q2","label":"styles_label__2jC8c"};